import Select from 'react-select'

const customStyles = {
  control: (base: any) => ({
    ...base,
    height: 50,
    fontSize: '16px',
    minHeight: 50,
    width: '100%',
    boxShadow: 'none',
    '&:hover': { borderColor: '#4f31ff' },
  }),
  option: (base: any, state: any) => {
    return {
      ...base,
      borderColor: '#4f31ff',
      fontSize: '16px',
      backgroundColor: state.isFocused
        ? '#4f31ff'
        : state.isSelected
          ? '#f0eeff'
          : '#ffffff',

      ':active': {
        backgroundColor: state.isSelected ? '#ffffff' : '#4f31ff',
      },
      color: state.isFocused ? '#ffffff' : '#333333',
    }
  },
  menu: (base: any) => ({ ...base, zIndex: 3 }),
  indicatorSeparator: () => ({ display: 'none' }),
}

interface DropdownComponentProps {
  options: {
    label: string
    value: string
  }[]
  name: string
  placeholder: string
  onChange: (e: any) => void
  value?: string
}

const DropdownComponent: React.FC<DropdownComponentProps> = ({
  name,
  placeholder,
  onChange,
  options,
  value,
}) => {
  const handleChange = (selectedOption: any) => {
    onChange({
      name,
      label: selectedOption.label,
      value: selectedOption.value,
    })
  }

  return (
    <Select
      isSearchable={false}
      styles={customStyles}
      name={name}
      placeholder={placeholder}
      onChange={handleChange}
      options={options}
      defaultValue={options.find((_, index) => index === 0)}
      {...(value
        ? {
            value: {
              value: value,
              label: options.find((option) => option.value === value)?.label,
            },
          }
        : {})}
    />
  )
}

export default DropdownComponent
